import { VFadeTransition } from 'vuetify/lib/components/transitions';
import { VIcon } from 'vuetify/lib/components/VIcon';

var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(VFadeTransition,{attrs:{"mode":"out-in"}},[_c(VIcon,{on:{"click":function($event){return _vm.isDarkFun()}}},[_vm._v(" "+_vm._s(_vm.$vuetify.theme.dark ? _vm.icons.mdiWeatherSunny : _vm.icons.mdiWeatherNight)+" ")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }